import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const faqs = [{
  q: 'Il mio problema è trovare clienti, non tenerli.',
  a: 'È il punto in cui quasi tutti si fermano. Ma un percorso previsto di otto sedute che si interrompe alla terza vale meno della metà di quello che poteva valere, e trovare un cliente nuovo costa molto più che portare a termine quello che hai già. Questo sistema non ti insegna a fare marketing: ti dà la struttura perché il lavoro che hai già in mano arrivi in fondo.'
}, {
  q: 'È l’ennesimo PDF tradotto dall’inglese.',
  a: 'No. Il quadro di riferimento è italiano: Legge 4/2013 e attestato di qualità dei servizi, ICF Italia, Asso.Co.Pro., AICP, A.Co.I., tariffe in euro, percorsi di 10 sedute come si contrattano qui — non i cicli lunghi del mercato americano. Il Volume 6 e il Kit Documenti esistono solo in questa edizione.'
}, {
  q: 'Ogni cliente è diverso, non si può standardizzare.',
  a: 'La struttura non sostituisce il tuo stile: lo sostiene. I 5 archetipi del Volume 2 servono proprio a calibrare l’approccio sulla persona che hai davanti. Quello che si standardizza è la conduzione del percorso, non la relazione.'
}, {
  q: 'Sembra una tecnica per trattenere le persone.',
  a: 'È l’opposto. Il cliente ha il diritto di fermarsi quando vuole, e nessun professionista può garantire un risultato. Il punto è che, se si ferma, se ne accorga prima lui di te — perché ha davanti una mappa e vede a che punto è. Non è un modo per trattenere i clienti. È un modo per farli arrivare in fondo.'
}, {
  q: 'Non sono ancora abbastanza bravo per un sistema così.',
  a: 'È il contrario: la struttura è quello che compensa le ore di volo che non hai ancora. Chi conduce percorsi da anni ha costruito il proprio sistema per prove ed errori, sui clienti. Qui il sistema è già scritto.'
}, {
  q: 'Ho già speso migliaia di euro nel master. Perché anche questo?',
  a: 'Il master ti ha insegnato a condurre una seduta. Questo ti dà il percorso intero: cosa succede tra la terza e la quinta, cosa consegni, come chiudi, come lo inquadri professionalmente. In Italia una seduta si paga tra €80 e €120: il confronto onesto è tra questo sistema e un solo percorso che si interrompe.'
}, {
  q: 'Chi c’è dietro?',
  a: 'Il sistema è nato dalla pratica di coaching professionale ed è stato riscritto per il contesto italiano. Non promette risultati e non vende una storia di successo: vende sei volumi e ventitré schede che puoi giudicare tu, con 7 giorni per farlo. [Completare con brand, autore e credenziali reali.]'
}, {
  q: 'Come lo ricevo, e posso usarlo con i miei clienti?',
  a: 'Download immediato in PDF dopo il pagamento, su qualsiasi dispositivo, stampabile. Le schede e i documenti destinati al cliente sono pensati per essere personalizzati con il tuo nome e usati nella tua pratica.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="w-full bg-white" data-id="element-97" data-mp="2zm1bfe41lznc">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-98" data-mp="33q8yz7yrl9jz">
        <h2 id="faq-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-99" data-mp="38ok81gh8jg15">
          Domande, con risposta
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-100" data-mp="3ievo21e71foe">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="rounded-2xl border border-cream-dark bg-cream overflow-hidden" data-id="element-101" data-mp="3ncdnn16bmijq" data-mpi={i}>
                <h3 data-id="element-102" data-mp="90nd5umr5xp">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4 sm:py-5 font-semibold text-ink hover:text-sage transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-sage/40" data-id="element-103" data-mp="98yas770169">
                    <span className="text-[15px] sm:text-base" data-id="element-104" data-mp="1go3cbs5u92db">{faq.q}</span>
                    <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-sage transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" data-mp="1gmacavpqdgea" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-106" data-mp="j25wk2iufb52">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-107" data-mp="xqalvpceikwt">
                      <p className="px-5 sm:px-6 pb-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-108" data-mp="2bwos6diaev0z">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}